import type { JSX } from "react";

import LivanceIconPrimary from "@repo/icons/colored/LivanceIconPrimary";

import { NavItems } from "@/components/ui/layout/bottom-bar/nav-items";
import { useNavItems } from "@/hooks/use-nav-items";

export const Sidebar = (): JSX.Element => {
  const navItems = useNavItems();

  return (
    <aside className="hidden md:flex flex-col w-[72px] min-w-[72px] bg-white border-r border-neutral-100 h-full md:z-10 md:relative">
      <div className="flex items-center justify-center h-22 shrink-0 border-b border-neutral-100">
        <LivanceIconPrimary size={48} title="Livance" />
      </div>
      <nav className="flex flex-col items-center gap-2 py-4">
        <NavItems items={navItems} className="flex w-full justify-center py-2" />
      </nav>
    </aside>
  );
};
